import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VForm,
    { ref: "formRef", staticClass: "d-flex flex-column gr-8 user-form" },
    [
      _vm.isLpu && "postpredstav" in _setup.userData
        ? [
            _c(VTextField, {
              staticClass: "mb-1",
              attrs: {
                label: _setup.t("Ваша должность", _setup.options),
                rules: _setup.validationRules.postpredstav,
                outlined: "",
              },
              model: {
                value: _setup.userData.postpredstav,
                callback: function ($$v) {
                  _vm.$set(_setup.userData, "postpredstav", $$v)
                },
                expression: "userData.postpredstav",
              },
            }),
            _vm._v(" "),
            _c(VTextField, {
              attrs: {
                label: _setup.t("Фамилия", _setup.options),
                rules: _setup.validationRules.surname,
                outlined: "",
              },
              model: {
                value: _setup.userData.surname,
                callback: function ($$v) {
                  _vm.$set(_setup.userData, "surname", $$v)
                },
                expression: "userData.surname",
              },
            }),
            _vm._v(" "),
            _c(VTextField, {
              attrs: {
                label: _setup.t("Имя", _setup.options),
                rules: _setup.validationRules.first_name,
                outlined: "",
              },
              model: {
                value: _setup.userData.first_name,
                callback: function ($$v) {
                  _vm.$set(_setup.userData, "first_name", $$v)
                },
                expression: "userData.first_name",
              },
            }),
            _vm._v(" "),
            _c(VTextField, {
              attrs: {
                label: _setup.t("Отчество", _setup.options),
                rules: _setup.validationRules.second_name,
                outlined: "",
              },
              model: {
                value: _setup.userData.second_name,
                callback: function ($$v) {
                  _vm.$set(_setup.userData, "second_name", $$v)
                },
                expression: "userData.second_name",
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(VTextField, {
        ref: "emailFieldRef",
        attrs: {
          "append-icon": "ui-icon-at-sign",
          label: _setup.t("Адрес электронной почты", _setup.options),
          rules: _setup.validationRules.email,
          placeholder: _setup.emailPlaceholder,
          outlined: "",
          "hide-details": _vm.isAlertForeignEmailVisible,
        },
        on: {
          blur: _setup.checkEmail,
          input: function ($event) {
            return _setup.emit("reset-email-error")
          },
        },
        model: {
          value: _setup.userData.email,
          callback: function ($$v) {
            _vm.$set(_setup.userData, "email", $$v)
          },
          expression: "userData.email",
        },
      }),
      _vm._v(" "),
      _c(
        VExpandTransition,
        [
          _vm.isAlertForeignEmailVisible
            ? _c(
                _setup.BaseAlert,
                { staticClass: "mt-2 mb-4", attrs: { color: "text-error" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _setup.t(
                          "По закону можно использовать только почту российских компаний. Например:",
                          _setup.options
                        )
                      ) +
                      "\n      "
                  ),
                  _c("ul", { staticClass: "my-2" }, [
                    _c("li", [_vm._v("Яндекс (@yandex.ru, @ya.ru)")]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "VK и Mail.ru (@vk.com, @mail.ru, @inbox.ru, @bk.ru, @list.ru, @internet.ru)"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v("Rambler (@rambler.ru, @ro.ru, @myrambler.ru)"),
                    ]),
                  ]),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _setup.t(
                          "Если хотите использовать корпоративную почту, напишите в поддержку",
                          _setup.options
                        )
                      ) +
                      "\n      "
                  ),
                  _c(
                    "a",
                    {
                      staticClass:
                        "primary--text link-decoration-underline cursor-pointer",
                      attrs: { href: "mailto:help@medrocket.ru" },
                    },
                    [_vm._v("help@medrocket.ru")]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(VTextField, {
        attrs: {
          autocomplete: "off",
          label: _setup.t("Придумайте пароль", _setup.options),
          type: _setup.isPasswordVisible ? "text" : "password",
          "append-icon": _setup.isPasswordVisible
            ? "ui-icon-eye-open"
            : "ui-icon-eye-close",
          rules: _setup.validationRules.password,
          placeholder: _setup.passwordPlaceholder,
          outlined: "",
        },
        on: {
          "click:append": function ($event) {
            _setup.isPasswordVisible = !_setup.isPasswordVisible
          },
        },
        model: {
          value: _setup.userData.password,
          callback: function ($$v) {
            _vm.$set(_setup.userData, "password", $$v)
          },
          expression: "userData.password",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }